import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="expandable-row"
// Simplified controller — Turbo handles timeline content loading.
// Uses nextElementSibling to avoid DOM restructuring that could break tablesort.
export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.isExpanded = false
  }

  toggle(event) {
    event.preventDefault()
    
    const detailsRow = this.element.nextElementSibling
    const isHidden = detailsRow.classList.contains("hidden")
    
    detailsRow.classList.toggle("hidden")
    this.iconTarget.style.transform = isHidden ? "rotate(90deg)" : "rotate(0deg)"
    this.element.setAttribute("aria-expanded", isHidden)
    
    // Update icon class for visual feedback
    if (isHidden) {
      this.iconTarget.classList.remove('fa-chevron-right')
      this.iconTarget.classList.add('fa-chevron-down')
    } else {
      this.iconTarget.classList.remove('fa-chevron-down')
      this.iconTarget.classList.add('fa-chevron-right')
    }
  }

  // Handle keyboard navigation
  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      this.toggle(event)
    }
  }
}
